import { jsx as _jsx } from "react/jsx-runtime";
import { chipClasses as muiChipClasses } from '@mui/material';
import { forwardRef } from 'react';
import { ChipWithShapeStyled } from './Chip.styled';
const Chip = forwardRef(({ shape = 'circle', ...muiChipProps }, ref) => {
    return _jsx(ChipWithShapeStyled, { ...muiChipProps, ref: ref, shape: shape });
});
export { Chip };
export const chipClasses = muiChipClasses;
